import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getEmpresas({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/empresas?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
